import React from 'react';
import { BrainCircuit, Save, History } from 'lucide-react';

const AiPromptTab = ({ jobData, handleInputChange, savedAiPrompts, setIsPromptManagerOpen, setJobData }) => {
  
  const handleSelectPrompt = (promptText) => {
    setJobData(prev => ({ ...prev, aiPrompt: promptText }));
  };

  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
        <BrainCircuit className="mr-2" />
        Asistente de Inteligencia Artificial
      </h3>

      <div className="space-y-4">
        <div>
          <label htmlFor="aiPrompt" className="block text-sm font-medium text-gray-700 mb-1">
            Prompt para la IA
          </label>
          <textarea
            id="aiPrompt"
            name="aiPrompt"
            rows="10"
            value={jobData.aiPrompt}
            onChange={handleInputChange}
            className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="Describe las instrucciones, objetivos y cualquier detalle crucial para que la IA pueda asistir en este trabajo..."
          ></textarea>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <button
                type="button"
                onClick={() => setIsPromptManagerOpen(true)}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 flex items-center gap-2"
            >
                <History size={16} /> Ver Prompts Guardados
            </button>
            {savedAiPrompts.length > 0 && (
                 <select onChange={(e) => handleSelectPrompt(e.target.value)} className="text-sm text-gray-700 border-gray-300 rounded-md" defaultValue="">
                    <option value="" disabled>Cargar prompt...</option>
                    {savedAiPrompts.map(p => (
                        <option key={p.id} value={p.prompt}>{p.name}</option>
                    ))}
                </select>
            )}
          </div>
           <button
            type="button"
            // onClick={handleSaveCurrentPrompt} // You can implement this logic if needed
            className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700 flex items-center gap-2"
          >
            <Save size={16} /> Guardar Prompt Actual
          </button>
        </div>
      </div>
    </div>
  );
};

export default AiPromptTab;
